<template>
  <div class="container">
    <div
      @click="toggleDropDown"
      :aria-expanded="isOpen.toString()"
      aria-haspopup="listbox"
      tabindex="0"
      @keyup.enter="toggleDropDown"
    >
      <span class="dropdown-text-cta" v-if="this.getSelectedStateName == null">
        shipping destination</span
      >
      <span class="dropdown-text-cta" v-else>{{
        this.getSelectedStateName
      }}</span>
    </div>
    <div
      class="drop-down"
      v-show="isOpen"
      ref="dropDown"
      role="listbox"
      aria-label="Select shipping destination"
    >
      <input
        ref="searchInput"
        class="search-input"
        type="text"
        placeholder="Search for state"
        v-model="searchQuery"
        @input="filterOptions"
        @keydown="handleKeyDown"
        tabindex="0"
        aria-label="Search for state"
      />
      <ul role="option">
        <li
          v-for="(option, index) in options"
          :key="index"
          @click="SetSelectedState(option)"
          :class="{ active: activeIndex === index }"
          :aria-selected="(index === activeIndex).toString()"
          :id="'option_' + index"
          tabindex="-1"
        >
          {{ option.StateName }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["DropDownvalues", "placeholderValue"],
  data() {
    return {
      isOpen: false,
      searchQuery: "",
      options: this.DropDownvalues,
      filteredOptions: null,
      activeIndex: -1
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    SetSelectedState(value) {
      this.$store.dispatch("user/updateSelectedState", value);
      this.$store.dispatch("product/updateLeadTime", this.$store);
      this.$store.dispatch("product/setIsLeadTimeLoading", true);
      this.isOpen = false;
    },
    filterOptions() {
      let tempOptions = this.DropDownvalues;
      let correctIndex;

      if (this.searchQuery != "" && this.searchQuery) {
        tempOptions = tempOptions.filter(item => {
          if (
            item.StateName.toLocaleLowerCase().startsWith(
              this.searchQuery.toLocaleLowerCase()
            )
          ) {
            correctIndex = this.searchQuery.length;
            return item.StateName.toLowerCase().startsWith(
              this.searchQuery.toLowerCase()
            );
          } else {
            return item.StateName.toLowerCase().startsWith(
              this.searchQuery.substring(0, correctIndex).toLowerCase()
            );
          }
        });
      }

      this.options = tempOptions;
    },
    toggleDropDown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus();
        });
      }
    },
    handleKeyDown(event) {
      if (event.key === "Enter" && this.activeIndex !== -1) {
        event.preventDefault();
        this.SetSelectedState(this.options[this.activeIndex]);
      } else if (event.key === "ArrowDown") {
        event.preventDefault();
        this.activeIndex = (this.activeIndex + 1) % this.options.length;
        this.scrollIntoView();
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        this.activeIndex =
          this.activeIndex <= 0
            ? this.options.length - 1
            : this.activeIndex - 1;
        this.scrollIntoView();
      } else if (event.key === "Escape") {
        event.preventDefault();
        this.isOpen = false;
      }
    },
    scrollIntoView() {
      this.$nextTick(() => {
        const activeItem = this.$refs.dropDown.querySelectorAll("li.active")[0];
        if (activeItem) {
          activeItem.scrollIntoView({ block: "nearest" });
        }
      });
    },
    handleClickOutside(event) {
      if (
        this.$refs.dropDown &&
        !this.$refs.dropDown.contains(event.target) &&
        !event.target.classList.contains("container") &&
        !event.target.classList.contains("dropdown-text-cta")
      ) {
        this.isOpen = false;
      }
    }
  },
  computed: {
    ...mapGetters("user", ["getUser", "getSelectedStateName"])
  }
};
</script>

<style lang="scss" scoped>
.container > div:first-of-type:focus {
  color: #8193a0;
}
.drop-down {
  position: absolute;
  background: #fff;
  top: calc(100% + 8px);
  box-shadow: 0px 1px 3px 1px rgba(38, 41, 44, 0.2);
  border-radius: 0px;
  z-index: 5;
  .search-input {
    cursor: text;
    color: rgb(38, 38, 38);
    font-size: 16px;
    font-family: $body;
    font-weight: normal;
    letter-spacing: 0.2px;
    line-height: 24px;
    height: 48px;
    text-decoration: none;
    width: 200px;
    border: 1px solid rgb(168, 168, 168);
    padding-left: 24px;
  }
  .search-input::placeholder {
    font-family: $body;
  }

  ul {
    list-style-type: none;
    padding: 0;
    width: 200px;
    height: 240px;
    overflow: auto;
    box-shadow: 0px 1px 3px 1px rgba(38, 41, 44, 0.2);
    border-radius: 0px;
    margin: 0px 0px;

    .active {
      background: rgb(242, 245, 248);
      border-radius: 0px;
    }
  }

  li {
    cursor: pointer;
    color: rgb(38, 38, 38);
    font-size: 16px;
    font-family: $body;
    font-weight: normal;
    letter-spacing: 0.2px;
    line-height: 24px;
    padding-left: 24px;
    padding-top: 8px;
    height: 48px;
    text-decoration: none;
  }
  li:hover {
    background: rgb(242, 245, 248);
    border-radius: 0px;
    cursor: pointer;
  }
  li:focus {
    background: rgb(242, 245, 248);
    border-radius: 0px;
    cursor: pointer;
  }
}
</style>
